var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('li',{on:{"click":_vm.run}},[_c('v-icon',{attrs:{"left":"","color":"light-blue"}},[_vm._v("ter-ispd")]),_vm._v(" Náhled v ISPD mapě ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }